module.exports = __webpack_public_path__ + "static/media/32.85f9fe61.JPG";